import { createContext } from 'react';

// This is internal, but TS throws a build-time error if we don't export it

const ResourceListContext = /*#__PURE__*/createContext({});

export { ResourceListContext };
